import React, { useState, useRef, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { DropDownGold } from '@/assets/images';
import type { List } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import Activity from './Activity/Activity';
import './ActivityListItem.scss';

interface Props {
	list: List;
	activities: [];
	index: number;
}

const ActivityListItem = ({ list, activities, index }: Props): JSX.Element => {
	const [selectedList] = useSelector(
		(state: RootState) => [
			state.dashboard.getIn(['lists', 'selected']).toJS()
		],
		shallowEqual
	);

	const [listItemOpened, setListItemOpened] = useState<boolean>(false);
	const listItemRef = useRef<HTMLDivElement>(null);

	const closeListItem = e => {
		if (!listItemRef?.current?.contains(e.target)) {
			const tempArr = [];
			const { classList } = e.target;

			for (let i = 0; i < classList.length; i++) {
				if (
					classList[i] === 'activity-list-item-header' ||
					classList[i] === 'activity-list-item-header-text' ||
					classList[i] === 'activity-list-item-header-icon'
				) {
					tempArr.push(true);
					break;
				}
			}

			if (
				classList[0] === 'activity-list-item' &&
				classList[classList.length - 1] !== list?.id
			) {
				setListItemOpened(false);
			}

			if (tempArr.length) {
				setListItemOpened(false);
			}
		}
	};

	useEffect(() => {
		window.addEventListener('click', closeListItem);

		return () => window.removeEventListener('click', closeListItem);
	}, []);

	useEffect(() => {
		if (selectedList?.id === list?.id) {
			setListItemOpened(true);
			return;
		}

		if (index === 0) {
			setListItemOpened(true);
		}
	}, []);

	return (
		<div
			key={list?.id}
			className={`activity-list-item ${listItemOpened ? 'opened' : ''} ${list?.id}`}
			onClick={e => setListItemOpened(!listItemOpened)}
		>
			<div className="activity-list-item-header" ref={listItemRef}>
				<span className="activity-list-item-header-text">
					{list?.name}
				</span>
				<DropDownGold className="activity-list-item-header-icon" />
			</div>
			<div
				className={`activity-list ${listItemOpened ? 'opened' : ''}`}
				style={{
					transform: `${listItemOpened ? 'scaleY(1)' : 'scaleY(0)'}`
				}}
				onClick={e => {
					e.stopPropagation();
				}}
			>
				{activities &&
					activities.map &&
					activities.map(activity => (
						<Activity
							listItemOpened={listItemOpened}
							activity={activity}
						/>
					))}
			</div>
		</div>
	);
};

export default ActivityListItem;
